"use strict";

var _require = require("guess-webpack/api"),
    guess = _require.guess;

exports.disableCorePrefetching = function () {
  return true;
};

var initialPath;
var notNavigated = true;

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (initialPath !== location.pathname) {
    notNavigated = false;
    return;
  }

  initialPath = location.pathname;
};

exports.onPrefetchPathname = function (_ref2, pluginOptions) {
  var loadPage = _ref2.loadPage;
  if (process.env.NODE_ENV !== "production") return;
  var matchedPaths = Object.keys(guess({
    path: window.location.pathname,
    threshold: pluginOptions.minimumThreshold
  })); // Don't prefetch from client for the initial path as we did that
  // during SSR

  if (!(notNavigated && initialPath === window.location.pathname)) {
    matchedPaths.forEach(loadPage);
  }
};